export const HEADER_HEIGHT = 60;
export const CLEAR_OPTION_VALUE = "__clear__";

export const FEATURE_REORDER_STOPS_TO_TRANSPAS =
  "updateStopOrderChangeToTranspas";
export const FEATURE_SHIPMENTS_DESKTOP_LAYOUT = "shipmentManagementDesktopUi";
export const FEATURE_TRAILER_EXCEPTION_FORM = "trailerExceptionForm";
export const FEATURE_EXCEPTIONS_DESKTOP_LAYOUT = "exceptionsDesktopUi";
export const FEATURE_CHAT = "chat";
export const FEATURE_TERMINAL_MANAGEMENT = "terminalManagement";
export const FEATURE_TERMINAL_UNCLEAR_SHIPMENTS = "terminalUnclearShipments";
export const FEATURE_REST_STOP = "restStop";

export const HOSTNAME_DEV = "dev.japp.fi";
export const HOSTNAME_STAGING = "staging.japp.fi";
export const HOSTNAME_TEST = "test.japp.fi";
export const HOSTNAME_PROD = "app.japp.fi";
export const HOSTNAME_LOCAL = "localhost";
